import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = {
    redirectUrl: String,
    delay: { type: Number, default: 1500 }
  }

  connect() {
    this.closeModal()
    
    this.scheduleRefresh()
  }

  closeModal() {
    const modal = document.querySelector('[data-controller*="modal-tailwind"]')
    if (modal) {
      const closeEvent = new CustomEvent('tw_modal:new_round_modal:close_modal')
      document.dispatchEvent(closeEvent)
    }
  }

  scheduleRefresh() {
    setTimeout(() => {
      this.refreshResultsOnly()
    }, this.delayValue)
  }

  refreshResultsOnly() {
    const url = window.location.href

    fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.text())
      .then(html => {
        const dom = new DOMParser().parseFromString(html, 'text/html')

        const newResults = dom.querySelector('[data-report-polling-target="resultsContainer"]')
        const newPagination = dom.querySelector('[data-report-polling-target="paginationContainer"]')

        const currentResults = document.querySelector('[data-report-polling-target="resultsContainer"]')
        const currentPagination = document.querySelector('[data-report-polling-target="paginationContainer"]')

        if (newResults && currentResults) {
          currentResults.innerHTML = newResults.innerHTML
        }

        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML
        }

        const event = new CustomEvent('turbo:load')
        document.dispatchEvent(event)
      })
      .catch(() => {
        window.location.reload()
      })
  }
}
